import React from 'react';

import { ListItemButton, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import { NavLink } from 'react-router';

interface IProps {
  icon: React.ReactNode;
  title: string;
  link: string;
}

const MenuItem = React.memo(({ icon, title, link }: IProps) => {
  const handleClick = React.useCallback((event: React.MouseEvent) => {
    event.stopPropagation();
  }, []);

  return (
    <ListItemButton
      component={NavLink}
      to={link}
      onClick={handleClick}
      sx={(theme) => ({
        '&.active': {
          backgroundColor: theme.palette.primary.main,
          '& svg path': {
            stroke: theme.palette.neutral.main,
          },
          '& .MuiListItemText-root .MuiTypography-root': {
            color: theme.palette.neutral.main,
          },
        },
      })}
    >
      <Tooltip title={title} placement="right">
        <ListItemIcon>{icon}</ListItemIcon>
      </Tooltip>

      <ListItemText
        primary={title}
        slotProps={{
          primary: {
            variant: 'h5',
          },
        }}
      />
    </ListItemButton>
  );
});

export default MenuItem;
